import { EmailConfig } from "../../model/EmailConfig";
import { EmailConfigRepository } from "../../repositories/Repository";

export class GetEmailConfigUseCase {
    constructor(private emailConfigRepository: EmailConfigRepository) { }
  
    async execute(): Promise<EmailConfig> {
      return await this.emailConfigRepository.getEmailConfig();
    }
  }